import dataType from '../dataType';

const lei = {
    name: 'LEI',
    type: dataType.string
};

export default lei;
